import { Text, TableContainer, Table, Thead, Tr, Tbody, Td, TableCaption, Flex, Spinner, useToast, Box } from '@chakra-ui/react'
import React, { useState, useEffect } from 'react'
import { api } from '../../../../services/api'
import { Th } from './Th'
import { NotasAntecipadas } from './NotasAntecipadas'
import { TrItem } from './TrItem'

const FiltroTabelas = ({ dados, resultado, view_loading_update, isNotasValidadas }) => {
  const [loadingUpdate, setloadingUpdate] = useState(false)
  const [notasAntecipadas, setNotasAntecipadas] = useState([])
  const [nunotaToUpdate, setNunotaToUpdate] = useState([])

  const toast = useToast()

  function getNotasAntecipadas() {
    const notas = dados.filter((item) => item.nota_antecipada === 'S')
    setNotasAntecipadas(notas)
  }

  useEffect(() => {
    getNotasAntecipadas()
  }, [dados])

  function handleNunotaToUpdate(nunota) {
    const existsNunota = nunotaToUpdate.find((item) => item === nunota)

    if (existsNunota) {
      const newNunotaToUpdate = nunotaToUpdate.filter((item) => item !== nunota)
      setNunotaToUpdate(newNunotaToUpdate)
    }

    if (!existsNunota) {
      setNunotaToUpdate([...nunotaToUpdate, nunota])
    }
  }

  return (
    <Box maxW={'1650px'} w={'full'} bg="white" mx="auto" boxShadow="md" borderRadius="md" py={3}>
      <Flex w={'full'} justifyContent={'space-between'} alignItems={'flex-end'} mb={'1rem'} paddingInline={5}>
        <Flex gap={'2rem'} ml="auto">
          <NotasAntecipadas dados={notasAntecipadas} resultado={resultado} />
          <Text as="h2" fontSize="1.2rem" fontWeight="bold" color="gray.600">
            {dados.length} pedidos
          </Text>

          {/* <ValidarNota nunotaToUpdate={nunotaToUpdate} resultado={resultado} clear={clearNunotaToUpdate} /> */}
        </Flex>
      </Flex>

      <TableContainer maxW={'1650px'} w={'full'}>
        <Table fontSize="12px">
          <TableCaption>Tabela de informações de notas fiscais pendentes de emissão</TableCaption>
          <Thead>
            <Tr>
              <Th label="Nº Ped" />
              <Th label="Nº Único" />
              <Th label="Limite Produção" />
              <Th label="Pré Danfe" />
              <Th label="Nome do cliente" />
              <Th label="Nome parc" />
              <Th label="Peso total" />
              <Th label="Peso real" />
              <Th label="Qtd de Caixas" />
              <Th label="Transp" />
              <Th label="Remessa" />
              <Th label="Valor nota" />
              <Th label={isNotasValidadas ? 'Usuário Validador' : 'Envio contabilidade'} />
              <Th label={isNotasValidadas ? 'NF-e Validada' : 'Validar nota'} />
            </Tr>
          </Thead>
          <Tbody>
            {view_loading_update && (
              <Tr>
                <Td colSpan="15" padding=".3rem" textAlign="center">
                  <Spinner size="md" color="green.500" />
                </Td>
              </Tr>
            )}
            {!view_loading_update &&
              dados.map((data, idx) => {
                return (
                  <TrItem
                    data={data}
                    key={idx}
                    idx={idx}
                    resultado={resultado}
                    getNotasAntecipadas={getNotasAntecipadas}
                    handleNunotaToUpdate={handleNunotaToUpdate}
                    isNotasValidadas={isNotasValidadas}
                  />
                )
              })}
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  )
}

export default FiltroTabelas
